import { render, staticRenderFns } from "./verLote.vue?vue&type=template&id=5b323375"
import script from "./verLote.ts?vue&type=script&lang=js&external"
export * from "./verLote.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b323375')) {
      api.createRecord('5b323375', component.options)
    } else {
      api.reload('5b323375', component.options)
    }
    module.hot.accept("./verLote.vue?vue&type=template&id=5b323375", function () {
      api.rerender('5b323375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/produto/verLote.vue"
export default component.exports